"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.SelectionCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Title = require("../../Elements/Title/Title");
var _Text = require("../../Elements/Text/Text");
var _Button = require("../../Elements/Button/Button");
var _Icon = require("../../Elements/Icon/Icon");
var _FormattedComposite = _interopRequireDefault(require("../../Elements/FormattedComposite/FormattedComposite"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SelectionCard = ({
  cardType,
  bodyData,
  bodyTextFormat,
  icon,
  image,
  onClick,
  isActive,
  buttonText,
  id
}) => {
  const cardId = id;
  const HorizontalCard = () => {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "ccl__horizontal-selection-card " + (isActive ? 'is-active' : ''),
      onClick: () => onClick(cardId),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "ccl__horizontal-selection-card--img-wrapper",
        children: [icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          className: "ccl__horizontal-selection-card--icon",
          color: "brand",
          size: "lg",
          type: icon
        }), image && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          className: "ccl__horizontal-selection-card--img",
          src: image
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "ccl__horizontal-selection-card--content-block d-flex justify-content-between align-self-center",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ccl__horizontal-selection-card--content-block",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedComposite.default, {
              config: bodyTextFormat,
              data: bodyData,
              labels: {
                title: 'Address'
              }
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
          content: buttonText,
          type: "interactive-text"
        })]
      })]
    });
  };
  const VerticalCard = () => {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "ccl__vertical-selection-card " + (isActive ? 'is-active' : ''),
      onClick: () => onClick(cardId),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ccl__vertical-selection-card--img-container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          className: "ccl__vertical-selection-card--img",
          src: image
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ccl__vertical-selection-card--content-block",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedComposite.default, {
            config: bodyTextFormat,
            data: bodyData,
            labels: {
              title: 'Address'
            }
          })
        })
      })]
    });
  };
  console.log("cardType:", cardType);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "selection-card-container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "destktop-variant d-none d-md-block ",
      children: [cardType.desktop == "horizontal" && /*#__PURE__*/(0, _jsxRuntime.jsx)(HorizontalCard, {}), cardType.desktop == "vertical" && /*#__PURE__*/(0, _jsxRuntime.jsx)(VerticalCard, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "mobile-variant d-block d-md-none",
      children: [cardType.mobile == "horizontal" && /*#__PURE__*/(0, _jsxRuntime.jsx)(HorizontalCard, {}), cardType.mobile == "vertical" && /*#__PURE__*/(0, _jsxRuntime.jsx)(VerticalCard, {})]
    })]
  });
};
exports.SelectionCard = SelectionCard;